// Factories Getters

export const getFactoriesList = state => {
  return state.factoriesList
}

export const getFactoryInfo = state => {
  return state.factoryInfo
}

export const getFullFactoriesList = state => {
  return state.fullFactoriesList
}
